import React from "react";

/**
 * THE SWITCH, AND IT IS THE SOURCE OF TRUTH.
 *
 * The mockup's annotation is worth restating because it decided the shape:
 * "the status pill can say Active while the switch is off only during a save
 * race, so we don't let that happen: toggling writes both."
 *
 * Here they cannot disagree at all, because the pill is DERIVED from the same
 * `enabled` the switch reads (see statusOf in AutomationsPage). There is one
 * fact and two renderings of it, rather than two facts kept in step.
 *
 * `pending` is what makes the round-trip honest. The switch shows the value it
 * is asking for and stays disabled until the server answers, so a failed PATCH
 * snaps it back rather than leaving the UI claiming something the database
 * never accepted.
 *
 * A real <button role="switch"> rather than a styled checkbox: it is operated
 * by keyboard for free, it announces its state, and the label goes in
 * aria-label rather than beside it, since the column header already says ON.
 */
export default function Switch({ on, onChange, pending = false, label, size = "md" }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!on}
      aria-label={label}
      className={`crm-switch crm-switch--${size}${on ? " is-on" : ""}${pending ? " is-pending" : ""}`}
      disabled={pending}
      onClick={(event) => {
        // The index row's whole surface opens the record, so the switch has to
        // stop the click reaching it — otherwise arming an automation also
        // navigates away from the list you were arming it from.
        event.stopPropagation();
        onChange(!on);
      }}
    >
      <span className="crm-switch__knob" />
    </button>
  );
}
